import React, {useState} from 'react';
import {Grid, InputBase} from "@material-ui/core";
import {withRouter} from 'react-router-dom'

import {makeStyles} from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: (theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: (theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    // pointerEvents: 'none',
    cursor: 'pointer',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(0)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

function Index(props) {
  const {pageTitle, addNewItem, addNewHandler} = props;

  const [search, setSearch] = useState('');
  const classes = useStyles();

  const searchHandler = () => {
    console.log('search')
    props.history.push('/searchResult')
  }
  return (
    <Grid item>
      <Grid container justify='space-between'>
        <Grid item className='display-flex align-items-center'>
          <h2 className='text-capitalize  mt-5 mb-5 heading-color'>{pageTitle} </h2>
          {addNewItem &&
            <p className=' ml-10  mb-5 font-12 heading-color mouse-pointer text-bold text-capitalize'
               onClick={addNewHandler}>
              {addNewItem}
            </p>}
        </Grid>
        {/*<Grid item>*/}
        {/*  /!*<input />*!/*/}
        {/*  <div className='display-flex align-items-center'>*/}
        {/*    <div className={classes.search} style={{border: '1px solid #E6E7E9', borderRadius: 10}}>*/}

        {/*      <InputBase*/}
        {/*        placeholder="Search…"*/}
        {/*        classes={{*/}
        {/*          root: classes.inputRoot,*/}
        {/*          input: classes.inputInput,*/}
        {/*        }}*/}
        {/*        inputProps={{'aria-label': 'search'}}*/}
        {/*        value={search}*/}
        {/*        onChange={(e) => {*/}
        {/*          // console.log(e.target.value);*/}
        {/*          setSearch(e.target.value)*/}
        {/*        }}*/}
        {/*      />*/}
        {/*      {search && <div className={classes.searchIcon} onClick={searchHandler}>*/}
        {/*        <SearchIcon/>*/}
        {/*      </div>}*/}
        {/*    </div>*/}

        {/*  </div>*/}
        {/*  /!**!/*/}
        {/*</Grid>*/}
      </Grid>
    </Grid>
  );
}

export default withRouter(Index);
